import { render, staticRenderFns } from "./RollSectionBand.vue?vue&type=template&id=5b3bcc89&scoped=true&"
import script from "./RollSectionBand.vue?vue&type=script&lang=js&"
export * from "./RollSectionBand.vue?vue&type=script&lang=js&"
import style0 from "./RollSectionBand.vue?vue&type=style&index=0&id=5b3bcc89&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3bcc89",
  null
  
)

export default component.exports